const DESIGN_ONE_PRODUCT = 'main[data-template="product.design-1"]';
const KACHING_ERROR_SELECTOR = [
  '.kaching-bundles__out-of-stock',
  '.kaching-bundles__bar--selected .kaching-bundles__invalid-variant-error',
].join(',');
const ADD_TO_CART_SELECTOR = [
  `${DESIGN_ONE_PRODUCT} [data-testid="standalone-add-to-cart"]`,
  `${DESIGN_ONE_PRODUCT} .sticky-add-to-cart__button`,
].join(',');

/** @param {Element} element */
function isVisible(element) {
  if (!(element instanceof HTMLElement) || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

  const style = getComputedStyle(element);
  return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
}

function hasBundleStockError() {
  return [...document.querySelectorAll(KACHING_ERROR_SELECTOR)].some(isVisible);
}

/** @param {HTMLButtonElement} button */
function disableForBundleStock(button) {
  if (!button.hasAttribute('data-kaching-stock-guard')) {
    button.dataset.kachingStockGuardWasDisabled = String(button.disabled);
  }

  button.dataset.kachingStockGuard = 'true';
  if (!button.disabled) button.disabled = true;
  if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
}

/** @param {HTMLButtonElement} button */
function restoreButtonState(button) {
  if (!button.hasAttribute('data-kaching-stock-guard')) return;

  const wasDisabled = button.dataset.kachingStockGuardWasDisabled === 'true';
  button.disabled = wasDisabled;

  if (!wasDisabled) button.removeAttribute('aria-disabled');

  delete button.dataset.kachingStockGuard;
  delete button.dataset.kachingStockGuardWasDisabled;
}

function syncAddToCartState() {
  if (!document.querySelector(DESIGN_ONE_PRODUCT)) return;

  const hasError = hasBundleStockError();
  document.querySelectorAll(ADD_TO_CART_SELECTOR).forEach((element) => {
    if (!(element instanceof HTMLButtonElement)) return;
    if (hasError) disableForBundleStock(element);
    else restoreButtonState(element);
  });
}

let syncFrame;
function scheduleSync() {
  if (syncFrame) cancelAnimationFrame(syncFrame);
  syncFrame = requestAnimationFrame(() => {
    syncFrame = undefined;
    syncAddToCartState();
  });
}

function blocksInvalidAddToCart(event) {
  if (!hasBundleStockError()) return false;

  event.preventDefault();
  event.stopImmediatePropagation();
  syncAddToCartState();
  return true;
}

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element) || !event.target.closest(ADD_TO_CART_SELECTOR)) return;
    blocksInvalidAddToCart(event);
  },
  true
);

document.addEventListener(
  'submit',
  (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (!event.target.closest(`${DESIGN_ONE_PRODUCT} product-form-component`)) return;
    blocksInvalidAddToCart(event);
  },
  true
);

const observer = new MutationObserver(scheduleSync);
observer.observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'disabled'],
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
else scheduleSync();
